import { useQuery } from "@tanstack/react-query";
import { aiApi } from "./ai.api";
import { aiKeys } from "./ai.keys";

export const useGetLimitationsQuery = (
  type: "image" | "text" | "translation",
) => {
  return useQuery({
    queryKey: aiKeys.limitations(type),
    queryFn: () => aiApi.getLimitations({ type }),
  });
};
